import { render, staticRenderFns } from "./TextPathProperties.vue?vue&type=template&id=ab59c24a&scoped=true"
import script from "./TextPathProperties.vue?vue&type=script&setup=true&lang=ts"
export * from "./TextPathProperties.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./TextPathProperties.vue?vue&type=style&index=0&id=ab59c24a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ab59c24a",
  null
  
)

export default component.exports